import { FC } from 'react';

import { Icon } from '@purpur/library/icon';
import { chevronLeft } from '@purpur/library/icon/assets/chevron-left';
import { chevronRight } from '@purpur/library/icon/assets/chevron-right';

import { useInitializeTranslations } from '@telialt/common-cms/src/useTranslations';

import { NavButtonBackward, NavButtonForward } from './NavArrowButton.styles';

type Props = {
    direction: 'forward' | 'backward';
    shown?: 'desktop-only' | 'always';
    dataTest?: string;
    onClick: () => void;
};

export const NavArrowButton: FC<Props> = ({ direction, dataTest, onClick, shown }) => {
    const { t } = useInitializeTranslations();
    if (!t) {
        return null;
    }

    const label = {
        forward: t['eshop.product_page.gallery.floating_button.next_image'],
        backward: t['eshop.product_page.gallery.floating_button.prev_image'],
    }[direction];
    const chevron = { forward: chevronRight, backward: chevronLeft }[direction];
    const NavButton = { forward: NavButtonForward, backward: NavButtonBackward }[direction];

    return (
        <NavButton data-test={dataTest} onClick={onClick} aria-label={label} $shown={shown}>
            <Icon svg={chevron} size="xs" />
        </NavButton>
    );
};
